import { render, staticRenderFns } from "./sticky_slot.vue?vue&type=template&id=1da9e05c&"
import script from "./sticky_slot.vue?vue&type=script&lang=js&"
export * from "./sticky_slot.vue?vue&type=script&lang=js&"
import style0 from "./sticky_slot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports